<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Rental Authorizations</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3"> 
          <br />
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <table class="table" >
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Customer Email</th>
                    <th scope="col">Customer</th>
                    <th scope="col">Stripe Setup Intent</th>
                    <th scope="col">Product</th>
                    <th scope="col">Deposit Amount</th>
                    <th scope="col">Estimate Value</th>
                    <th scope="col">Date</th>
                  </tr>   
                </thead>
                <tbody>
                  <tr *ngFor="let i of transactions; let a = index">
                    <th scope="row">{{ transactions.length - a }}</th>
                    <td>{{ i.email }}</td>
                    <td><a href="https://dashboard.stripe.com/customers/{{ i.stripe_id }}" target="_blank">Customer <i class="fa fa-paper-plane"></i></a></td>
                    <td>{{ i.paymentintent }}</td>
                    <td>{{ i.productid }} - {{ i.product_name }}</td>
                    <td>${{ i.damount }}</td>
                    <td>${{ i.evalue }}</td>
                    <td>{{ i.date | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
